import { EnumCountryKey } from "src/types/common-enum";
import { SearchQueryParams } from "../search.types";

export const mapIsInvestableToQuery = (isInvestable: boolean) => {
    return isInvestable ? `${SearchQueryParams.IsInvestable}=true` : "";
};

export const mapIsChInvestableToQuery = (isChInvestable: boolean, country: string) => {
    return isChInvestable && country === EnumCountryKey.CH ? `${SearchQueryParams.IsChInvestable}=true` : "";
};

export const mapIsAtInvestableToQuery = (isAtInvestable: boolean, country: string) => {
    return isAtInvestable && country === EnumCountryKey.AT ? `${SearchQueryParams.IsAtInvestable}=true` : "";
};
